import HTTPService from "@/services/http_service.js";
import { global } from "@/config/constants";

export default class CentroCustoService extends HTTPService {
  resource = "centro-custo";

  static build() {
    return new CentroCustoService();
  }

  getCentroCustoPaginatedList({ page, per_page, search, order, desc }) {
    return this.get(this.resource, {
      page,
      per_page,
      search,
      order,
      desc,
    });
  }

  async register(centro_custo) {
    const headers = new Headers();

    const token = JSON.parse(sessionStorage.getItem("vuex")).token;
    headers.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      body: centro_custo,
      headers: headers,
    };
    return await fetch(
      `${global.api.baseURL}/${this.resource}`,
      requestOptions
    ).then(async (response) => {
      return response;
    });
  }

  async editarCentroCusto(centroCustoId, centroCusto) {
    const headers = new Headers();
    const token = JSON.parse(sessionStorage.getItem("vuex")).token;
    headers.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      body: centroCusto,
      headers: headers,
    };
    return await fetch(
      `${global.api.baseURL}/${this.resource}/${centroCustoId}`,
      requestOptions
    ).then(async (response) => {
      return response;
    });
  }

  async deletarCentroCusto(centroCustoId) {
    const headers = new Headers();
    const token = JSON.parse(sessionStorage.getItem("vuex")).token;
    headers.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      headers: headers,
    };
    return fetch(
      `${global.api.baseURL}/${this.resource}/${centroCustoId}/deletar`,
      requestOptions
    ).then(async (response) => {
      return response;
    });
  }
}
